module.exports = __webpack_public_path__ + "605c633c45b3d908822f85b5a0e195d8.png";